var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 322 319.7284851",
    enableBackground: "new 0 0 1000 319.7284851",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#241A30",
    d: "M164.0085602,318.8161011 c-31.5135651,0-46.1585617-4.6004944-71.614769-23.002594c-16.1018295,20.7023315-67.0909348,36.8808594-69.3145142,9.2010498 c0-20.7790222-4.6005192-38.337677-9.8144436-57.5065155C7.054132,223.8920135,0,197.5923615,0,159.484726 C0,68.4710846,74.6817856,0,163.1651459,0c88.5600128,0,157.9512177,71.8448029,157.9512177,160.3281403 C321.4136047,247.443161,251.1228333,318.3513794,164.0085602,318.8161011z M165.3120422,78.6689148 c-43.0915375-2.2235794-76.6753464,27.6031265-84.112854,74.3750916 c-6.1340332,38.7210541,4.7538681,85.8764038,14.0315857,88.3300018 c4.4471664,1.0734558,15.6417694-7.9742432,22.6192245-14.9516907 c11.5375748,7.9704437,24.9729691,12.7574768,38.9510727,13.8782349 c44.6499329,2.1477356,82.80159-31.8444214,85.7997131-76.4453125c1.7453156-44.6953049-32.6325836-82.551918-77.2887573-85.109642 L165.3120422,78.6689148z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMax);
export default __webpack_public_path__ + "static/media/max.c64b3eee59a4d45ca9fc7687ddc1d797.svg";
export { ForwardRef as ReactComponent };